import { WrapperWidget } from '@agentselly/ui';
import { LoadingSpinner } from '~/components/global/LoadingSpinner';

export function LoadingWidget() {
  return (
    <WrapperWidget>
      <div className="min-h-32 flex items-center justify-center">
        <LoadingSpinner />
      </div>
    </WrapperWidget>
  );
}
